"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const withJourney_1 = __importDefault(require("../../../hocs/withJourney"));
const helpers_1 = require("../../../lib/helpers");
const useAddToForwardRef_1 = require("../../../hocs/useAddToForwardRef");
const InputContext_1 = require("../../../contexts/InputContext");
const useInputForm_1 = require("../../../hooks/useInputForm");
const InputDiv = (props) => {
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    const divProps = helpers_1.without(primitiveProps, ['name', 'min', 'max', 'onChange', 'marks', 'placeholder', 'value', 'inputMode', 'autoComplete']);
    let hasLabel = !!props.label || !!props.name;
    if (props.label === '') {
        hasLabel = false;
    }
    const contextDivRef = react_1.useRef(null);
    const ref = useAddToForwardRef_1.useAddToForwardRef(props, [contextDivRef]);
    /* Form value or prop.value */
    const inputValue = useInputForm_1.useInputValue(props);
    return (react_1.default.createElement(InputContext_1.InputContext.Provider, { value: { value: inputValue, placeholder: props.placeholder, error: props.error, label: props.label, name: props.name, divRef: contextDivRef } },
        react_1.default.createElement("div", Object.assign({}, divProps, { className: classnames_1.default(divProps.className, { 'has-label': hasLabel }), ref: ref }), props.children)));
};
exports.default = withJourney_1.default('j-input', InputDiv);
